import { SweetpassCheckoutScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <SweetpassCheckoutScreen />;
}
